import Vue from 'vue'
import Router from 'vue-router'
import Page from './views/Page.vue'
import HomeElement from './components/HomeElement.vue'
import AboutElement from './components/AboutElement.vue'
import TechElement from './components/TechElement.vue'
import SettingsElement from './components/SettingsElement.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: Page,
      children: [
        {
          path: '/',
          name: 'start',
          component: HomeElement
        }
      ]
    },
    {
      path: '/page',
      component: Page,
      children: [
        {
          path: 'impressum',
          name: 'about',
          component: AboutElement
        },
        {
          path: 'tech',
          name: 'tech',
          component: TechElement
        },
        {
          path: '/',
          component: HomeElement
        },
        {
          path: 'einstellungen',
          name: 'settings',
          component: SettingsElement
        }
      ]
    },
    {
      path: '/abfahrten',
      name: 'departures',
      component: () => import(/* webpackChunkName: "departures" */ './views/Departures.vue')
    }
  ]
})
